<div class="editor">
  <EXP__glxy-wrap>
    <div class="error-alert" *ngIf="addDropdownDisabled$ | async">
      <glxy-alert type="error">
        <strong>{{ 'ADMINISTRATION.CUSTOM_FIELDS.REACHED_CREATION_LIMIT' | translate }} —</strong>
        {{ 'COMMON.AUXILIARY_DATA.SCHEMA.DROPDOWN.OPTION_FIELDS_LIMIT' | translate }}
      </glxy-alert>
    </div>
  </EXP__glxy-wrap>

  <glxy-form-field [bottomSpacing]="false" *ngIf="showObjectTypeControl" class="object-type-form-field">
    <glxy-label>
      {{ 'COMMON.AUXILIARY_DATA.SCHEMA.OBJECT' | translate }}
      <mat-icon
        class="field-type-warning-icon"
        matTooltip="{{ 'ADMINISTRATION.CUSTOM_FIELDS.FIELD_TYPE_NOT_EDITABLE' | translate }}"
      >
        info_outline
      </mat-icon>
    </glxy-label>
    <mat-select
      (selectionChange)="selectObjectType($event.value)"
      [value]="objectType.value"
      [disabled]="!createNewField"
      [required]="true"
      disableOptionCentering
      panelClass="object-type-options__for-custom-fields-edit-side-panel"
    >
      <mat-option *ngFor="let option of objectTypeOptions" [value]="option.value">
        {{ option.labelKey | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>

  <glxy-form-field [bottomSpacing]="false">
    <glxy-label>{{ 'COMMON.AUXILIARY_DATA.SCHEMA.NAME' | translate }}</glxy-label>
    <input type="text" matInput #nameInput="matInput" [formControl]="name" maxlength="50" />
    <glxy-hint align="end" [ngClass]="{ 'hidden-hint': !nameInput.focused }">
      {{ 'ADMINISTRATION.CUSTOM_FIELDS.NAME_HINT' | translate: { characters: name?.value?.length || 0 } }}
    </glxy-hint>
  </glxy-form-field>
  <aux-external-id
    [createNewField]="createNewField"
    [externalIdFormControl]="externalId"
    [name]="name.value"
    [objectType]="objectType.value"
  ></aux-external-id>

  <glxy-form-field [bottomSpacing]="false">
    <glxy-label>{{ 'COMMON.AUXILIARY_DATA.SCHEMA.DESCRIPTION' | translate }}</glxy-label>
    <textarea
      type="text"
      matInput
      [formControl]="description"
      data-testid="field-description"
      maxlength="200"
      rows="3"
      #descriptionInput="matInput"
    ></textarea>
    <glxy-hint align="end" [ngClass]="{ 'hidden-hint': !descriptionInput.focused }">
      {{ 'ADMINISTRATION.CUSTOM_FIELDS.DESCRIPTION_HINT' | translate: { characters: description?.value?.length || 0 } }}
    </glxy-hint>
  </glxy-form-field>

  <glxy-form-field [bottomSpacing]="false">
    <glxy-label>
      {{ 'COMMON.AUXILIARY_DATA.SCHEMA.TYPE' | translate }}
      <mat-icon
        class="field-type-warning-icon"
        matTooltip="{{ 'ADMINISTRATION.CUSTOM_FIELDS.FIELD_TYPE_NOT_EDITABLE' | translate }}"
      >
        info_outline
      </mat-icon>
    </glxy-label>
    <mat-select
      (selectionChange)="selectType($event.value)"
      [value]="selectedType.value"
      [disabled]="!createNewField"
      [required]="true"
    >
      <mat-option *ngFor="let typeOption of validTypeOptions$ | async" [value]="typeOption.value">
        {{ typeOption.label | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>

  <aux-currency-choice *ngIf="typeIsCurrency$ | async" [currencyFormControl]="selectedCurrency"></aux-currency-choice>

  <table [dataSource]="dropdownTableRows$$" mat-table *ngIf="showDropdownOptions$ | async" class="dropdown-table">
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>
        <div class="table-center-vertical">
          {{ 'COMMON.AUXILIARY_DATA.SCHEMA.DROPDOWN.LABEL' | translate }}
          <mat-icon matTooltip="{{ 'COMMON.AUXILIARY_DATA.SCHEMA.DROPDOWN.LABEL_HINT' | translate }}">
            info_outline
          </mat-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <input type="text" matInput [formControl]="element.controls.label" maxlength="100" />
      </td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>
        <div class="table-center-vertical">
          {{ 'COMMON.AUXILIARY_DATA.SCHEMA.DROPDOWN.VALUE' | translate }}
          <mat-icon matTooltip="{{ 'COMMON.AUXILIARY_DATA.SCHEMA.DROPDOWN.VALUE_HINT' | translate }}">
            info_outline
          </mat-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <input type="text" matInput [formControl]="element.controls.value" />
      </td>
    </ng-container>
    <ng-container matColumnDef="create-remove">
      <th mat-header-cell *matHeaderCellDef class="last-column">
        <button
          (click)="addDropdownOption()"
          mat-stroked-button
          type="button"
          [disabled]="addDropdownDisabled$ | async"
        >
          <mat-icon aria-hidden="false" aria-label="add option">add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element; let i = index" class="last-column">
        <button
          (click)="removeDropdownOption(i)"
          [disabled]="removeDropdownDisabled$ | async"
          class="dropdown-option__remove"
          mat-stroked-button
          type="button"
        >
          <mat-icon aria-hidden="false" aria-label="remove option">delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="dropdownTableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: dropdownTableColumns"></tr>
  </table>
</div>
